<template>
  <div>
    <van-nav-bar
    ref="nav"
    @click-left="$store.dispatch('back')"
    placeholder
    :fixed="true"
    title="确认订单"
  >
    <template #left>
      <van-icon size="40rpx" name="arrow-left" color="#333" /> </template
  ></van-nav-bar>
  <div class="make-order">
    <OrderCard v-for="card of list" :key="card.id" :cardData="card"></OrderCard>
  </div>
  <div class="footer">
    <div class="price">
      合计：<span>¥{{ price }}</span>
    </div>
    <div class="btn" @click="makeOrder">确认支付</div>
  </div>
  </div>
</template>


<script>
//    import Vue from 'vue'
//     import VConsole from 'vconsole';
// Vue.prototype.Vconsole = new VConsole()

import store from "@/store/index.js";
import OrderCard from "@/components/OrderCard";
// import ActionBar from "vant/es/action-bar/index";
// import "vant/es/action-bar/style/index";

export default {
  components: { OrderCard, 
  // ActionBar 
  },
  computed: {
    partalName() {
      return store.state.partal.name;
    },
  },
  data() {
    return {
      goods_sku_id: "",
      list: [],
      price: 0,
      device: "h5",
    };
  },
  async mounted () {
 
    let option = this.$route.query
    
   
    if (option.partal) {
      this.$store.commit("setPartal", option.partal);
    }
    if (option.token) {
      this.$store.dispatch("tokenLogin", option.token);
    }

    this.goods_sku_id = option.goods_sku_id;
    this.device = option.device || "";
    let res = await this.$api({
      url: "/api/goods/preview",
      data: {
        goods_sku_id: this.goods_sku_id,
      },
    });
    if (res.code == 0) {
      console.log(res.data);
      this.list = res.data.course_list;
      this.price = 0;
      for (const iterator of this.list) {
        this.price += iterator.price * 1;
      }
    }
    if (this.$wechat && this.$wechat.isWechat()) {
      this.$wechat.initJssdkShare();
    }
  },
  methods: {

    async makeOrder() {
      var payPrice = Number(this.list[0].price);
      
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      console.log(this.$store.state.plat_id)
      let { is_admin, mobile } = this.$store.state.user;
      if (mobile == "17600789950" || mobile == "17600789951" || mobile == "18666666661" || is_admin) {
        payPrice = 0.01;
      }
      if(this.$until.isWeiXin()){
      
        this.wxPay(payPrice)
      }else{
        this.noWxPay(payPrice)
      }
      
    },
    // 非微信环境支付
    async noWxPay(payPrice){
      let res = await this.$api({
              url: "/api/order/make",
              method: "POST",
              data: {
                pay_type: 7,
                amount: payPrice,
                goods_sku_id: this.goods_sku_id,
                amount_coin: 0,
                amount_diamond: 0,
                amount_award: 0,
              },
            });
            console.log(res)
            if (res.code == 0) {
              if(this.list.is_free==2){
                this.$toast('购买成功')
                setTimeout(()=>{
                  this.$router.push('../user/purchased')
                },1500)
                return
              }
              let payInfo = res.data.pay
              window.location.href = payInfo.mweb_url+ '&redirect_url=' + encodeURIComponent(window.location.href+'#/'+this.$route.params.plat_type+'/user/purchased')
              this.$toast.clear();
              
            } else {
              this.$toast.clear();
              this.$toast(res.msg);
            }
    },
    // 微信环境支付
    async wxPay(payPrice){
      console.log('微信支付2')
      let res = await this.$api({
              url: "/api/order/make",
              method: "POST",
              data: {
                platform_id: this.$store.state.plat_id,
                pay_type: 9,
                amount: payPrice,
                goods_sku_id: this.goods_sku_id,
                // recharge: 0,
                amount_coin: 0,
                amount_diamond: 0,
                amount_award: 0,
                // openid:'okur0wV-ZP-CP1iFRP5dyAZCIfKY'
                openid: localStorage.getItem('openid'),
              },
            });
            if (res.code == 0) {
              let payInfo = res.data.pay
              this.$toast.clear();
              // this.$wechat.pay(payInfo)
              if(this.list.is_free==2){
                this.$toast('购买成功')
                setTimeout(()=>{
                  this.$router.push('../user/purchased')
                },1500)
                return
              }
              function onBridgeReady() {
                WeixinJSBridge.invoke(
                  "getBrandWCPayRequest",
                  {
                    appId: "wxb1d573e34d48cbf6",
                    timeStamp: payInfo.timeStamp + "", //时间戳，自1970年以来的秒数
                    nonceStr: payInfo.nonceStr, //随机串
                    package: payInfo.package,
                    signType: payInfo.signType, //微信签名方式：
                    paySign: payInfo.paySign, //微信签名◊
                  },
                  function (res) {
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                      this.$toast({
                        title: "支付成功",
                        icon: "none",
                      });
                      setTimeout(() => {
                        this.$router.replace('../user/purchased')
                        // this.$store.dispatch("reJump", {
                        //   path: "../user/purchased",
                        //   params: "",
                        // });
                      }, 300);
                    }
                  }
                );
              }
              if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                  document.addEventListener(
                    "WeixinJSBridgeReady",
                    onBridgeReady,
                    false
                  );
                } else if (document.attachEvent) {
                  document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
                  document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
                }
              } else {
                onBridgeReady();
              }
              return;
              if (this.$wechat && this.$wechat.isWechat()) {
                this.$wechat.pay(res.data.pay);
              } else {
                this.$toast({
                  title: "不是微信环境",
                });
              }
            } else {
              this.$toast.clear();
              this.$toast(res.msg);
            }
    }
  }
};
</script>

<style scoped>
.make-order {
  padding-top: 26px;
}

.footer {
  width: 100%;
  height: 130px;
  background: #ffffff;
  box-shadow: 0px -1rpx 5rpx 0px #ddd9d9;
  position: fixed;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: constant(safe-area-inset-bottom);
}

.price {
  font-size: 32px;
  color: #333;
  padding-left: 30px;
}
.price span {
  font-size: 46px;
  color: #ff4d41;
  font-weight: 600;
  letter-spacing: 2px;
}

.btn {
  width: 332px;
  height: 80px;
  background: #a7090a;
  border-radius: 40px;
  color: #fff;
  display: flex;
  font-size: 34px;
  align-items: center;
  justify-content: center;
  margin-right: 30px;
}
</style>